/**
 * P2P protocol helpers.
 * Room code generation, message serialization, team hashing.
 */

import type { P2PMessage, TrainerProfile } from "../engine/types";
import { APP_VERSION } from "../config/constants";

export function generateRoomCode(): string {
  const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
  let code = "";
  for (let i = 0; i < 6; i++) {
    code += chars[Math.floor(Math.random() * chars.length)];
  }
  return code;
}

export function codeToRoomId(code: string): string {
  return `pbs-${code.toUpperCase()}`;
}

export function roomIdToCode(roomId: string): string {
  return roomId.replace(/^pbs-/, "");
}

export function serializeMessage(msg: P2PMessage): string {
  return JSON.stringify(msg);
}

export function deserializeMessage(data: string | object): P2PMessage | null {
  try {
    const obj = typeof data === "string" ? JSON.parse(data) : data;
    if (obj && typeof obj.type === "string") {
      return obj as P2PMessage;
    }
  } catch {
    // invalid
  }
  return null;
}

export async function teamHash(members: unknown[]): Promise<string> {
  const text = JSON.stringify(members);
  const encoder = new TextEncoder();
  const data = encoder.encode(text);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((b) => b.toString(16).padStart(2, "0")).join("").slice(0, 16);
}

export function buildHello(profile: TrainerProfile): P2PMessage {
  return { type: "HELLO", profile, clientVersion: APP_VERSION };
}

export async function buildTeam(teamMembers: unknown[]): Promise<P2PMessage> {
  const hash = await teamHash(teamMembers);
  return { type: "TEAM", teamHash: hash };
}

export function isVersionCompatible(theirVersion: string): boolean {
  return theirVersion === APP_VERSION;
}